export enum AssessmentLanguages {
    ENGLISH = "ENGLISH",
    HINDI= "HINDI",
    BENGALI = "BENGALI",
}